import * as _ from 'lodash';

import * as Types from './model/types';

export function constNodeUnsafe<T extends Types.Type>(type: T, value: any) {
  return {
    nodeType: 'const' as const,
    type,
    val: value,
  };
}

export function constNode<T extends Types.Type>(
  type: T,
  value: Types.TypeToTSTypeInner<T>
) {
  return {
    nodeType: 'const' as const,
    type,
    val: value,
  };
}

export function constString(s: string): Types.ConstNode<'string'> {
  return {
    nodeType: 'const',
    type: 'string',
    val: s,
  };
}
// WIP Working on memoizing all ops
// export const constString = _.memoize(
//   (s: string): Types.ConstNode<'string'> => {
//     return {
//       nodeType: 'const',
//       type: 'string',
//       val: s,
//     };
//   }
// );
export function constNumber(n: number): Types.ConstNode<'number'> {
  return {
    nodeType: 'const',
    type: 'number',
    val: n,
  };
}
// WIP Working on memoizing all ops
// export const constNumber = _.memoize(
//   (n: number): Types.ConstNode<'number'> => {
//     return {
//       nodeType: 'const',
//       type: 'number',
//       val: n,
//     };
//   }
// );
export function constNumberList(
  n: number[]
): Types.ConstNode<{type: 'list'; objectType: 'number'}> {
  return {
    nodeType: 'const',
    type: {type: 'list', objectType: 'number'},
    val: n,
  };
}

export function constStringList(
  s: string[]
): Types.ConstNode<{type: 'list'; objectType: 'string'}> {
  return {
    nodeType: 'const',
    type: {type: 'list', objectType: 'string'},
    val: s,
  };
}

export function constBoolean(b: boolean): Types.ConstNode<'boolean'> {
  return {
    nodeType: 'const',
    type: 'boolean',
    val: b,
  };
}

export function constLink(name: string, url: string): Types.ConstNode<'link'> {
  return {
    nodeType: 'const',
    type: 'link',
    val: {name, url},
  };
}

export function constDate(date: Date): Types.ConstNode<'date'> {
  return {
    nodeType: 'const',
    type: 'date',
    val: date,
  };
}

export function varNode<T extends Types.Type>(
  type: T,
  varName: string
): Types.VarNode<T> {
  return {
    nodeType: 'var',
    type,
    varName,
  };
}

export function defineFunction<
  InputTypes extends {[key: string]: Types.Type},
  ReturnType extends Types.Type
>(
  parameters: InputTypes,
  fnBody: (inputs: {
    [K in keyof InputTypes]: Types.VarNode<InputTypes[K]>;
  }) => Types.NodeOrVoidNode<ReturnType>
): Types.ConstNode<
  Types.FunctionTypeSpecific<InputTypes, ReturnType | 'invalid'>
> {
  const varNodes = _.mapValues(parameters, (paramType, varName) =>
    varNode(paramType, varName)
  );
  const fnNode = fnBody(varNodes as any);
  return {
    nodeType: 'const',
    type: {type: 'function', inputTypes: parameters, outputType: fnNode.type},
    // TODO: why any here?
    val: fnNode as any,
  };
}

export function constNone(): Types.ConstNode<'none'> {
  return {
    nodeType: 'const',
    type: 'none',
    val: null,
  };
}
